<!--https://v3.ru.vuejs.org/ru/guide/migration/v-model.html#%D0%B0%D1%80%D0%B3%D1%83%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-v-model-->
<!--https://chrysanthos.xyz/article/how-to-get-the-data-of-a-proxy-object-in-vue-js-3/-->

<template>
  <section class="section-form" v-show="loading">
    <!--    <pre>-->
    <!--      <code>-->
    <!--        {{getLicense}}-->
    <!--      </code>-->
    <!--    </pre>-->

    <div id="form-section" class="flex-grid form-grid">
      <div class="forms-tabs">
        <div class="form-title">{{formTitle}}</div>
        <div class="swiper-tabs">

          <ul
              class="tabs-ul tabs-3"
              :class="countHeaders"
          >

            <li v-if="!loading">Loading</li>
            <li
                v-else
                v-for="item in menu_headers"
                :key="item.id"
                class="tab-link"
                :data-tab="'tab-' + item.sort"
                :data-hash="item.hash"
                @click="menuItemClick(item.hash, $event)"
                :class="{current: activeForm === item.hash}"
            >{{ item.label }}
            </li>

            <li class="mark"></li>
          </ul>

<!--          <br>activeForm: {{activeForm}}<br>-->

        </div>


        <div class="tab-container-wrap">
          <div id="tab=1" class="tab-container current">
            <div class="form-main">
              <form id="download_form" action="#" method="post" autocomplete="off" style="display: block;" v-show="!thankYouBlockShow">

                <div class="input-field select" id="download_product_wrapper">
                  <select
                      id="download_product"
                      class="select-text vue vue-2023"
                      v-model="product"
                      ref="productRef"
                  >
                  </select>
                  <div class="select-label">{{ labels.product }}</div>
                </div>


                <div
                    class="input-field select"
                    :class="{ 'field-error' : VSANSubProductError, 'selected': sub_product_class_selected, 'not-selected': !sub_product_class_selected }"
                    id="download_sub_product_wrapper"
                    v-show="showSubProduct"
                >
                  <select
                      id="download_sub_product"
                      class="select-text"
                      v-model="sub_product"
                      ref="subProductRef"
                  >
                  </select>
                  <div class="select-label">{{subProductLabel}}</div>
                  <span
                      v-if="VSANSubProductError"
                      v-html="VSANSubProductErrorMessage"
                      class="error"
                  ></span>
                </div>


                <div
                    class="input-field"
                    :class="{ 'field-error': firstnameError }"
                >
                  <input
                      id="download_firstname"
                      name="firstname"
                      type="text"
                      required="required"
                      class="input"
                      v-model="firstname"
                  >

                  <span
                      v-if="firstnameError"
                      v-html="firstnameErrorMessage"
                      class="error"
                  ></span>

                  <label for="download_firstname" class="label">{{ labels.firstname }}</label>
                </div>


                <div
                    class="input-field"
                    :class="{ 'field-error': lastnameError }"
                >
                  <input
                      id="download_lastname"
                      type="text"
                      required="required"
                      class="input"
                      v-model="lastname"
                  >

                  <span
                      v-if="lastnameError"
                      v-html="lastnameErrorMessage"
                      class="error"
                  ></span>

                  <label for="download_lastname" class="label"> {{ labels.lastname }} </label></div>


                <div
                    class="input-field"
                    :class="{ 'field-error': emailError }"
                >
                  <input
                      id="download_email"
                      type="text"
                      required="required"
                      class="input"
                      v-model="email"
                  >
                  <span v-if="emailError" v-html="emailErrorMessage" class="error"></span>
                  <label for="download_email" class="label">{{labels.email}}</label>
                </div>

                <div
                    class="input-field"
                    :class="{ 'field-error': titleError }"
                >
                  <input
                      id="download_title"
                      type="text"
                      required="required"
                      class="input"
                      v-model="title"
                  >
                  <span v-if="titleError" v-html="titleErrorMessage" class="error"></span>

                  <label
                      for="download_title"
                      class="label"
                  >
                    {{labels.title}}
                  </label>
                </div>

                <div
                    class="input-field"
                    :class="{ 'field-error': companyError }"
                >
                  <input
                      id="download_company"
                      type="text"
                      required="required"
                      class="input"
                      v-model="company"
                  >

                  <span
                      v-if="companyError"
                      v-html="companyErrorMessage"
                      class="error"
                  ></span>

                  <label
                      for="download_company"
                      class="label">{{ labels.company }}
                  </label>
                </div>


                <div
                    class="input-field select"
                    :class="{ countryShow: !countryShow, 'field-error': countryError}"
                >
                  <select
                      id="download_country"
                      class="select-text vue"
                      v-model="country"
                      ref="countryRef"
                  >
                  </select>
                  <div class="select-label">{{ labels.country }}</div>
                  <span
                      v-if="countryError"
                      v-html="countryErrorMessage"
                      class="error"
                  ></span>
                </div>


                <div
                    class="input-field select"
                    v-show="(country === 'United States') || (country === 'Canada')"
                    :class="{'field-error': stateError}"
                >
                  <!--                    :class="{ countryShow: !countryShow, 'field-error': countryError}"-->

                  <select
                      id="download_state"
                      class="select-text vue"
                      v-model="countryState"
                      ref="stateRef"
                  >
                  </select>
                  <div class="select-label">{{ labels.state }}</div>
                  <span
                      v-if="stateError"
                      v-html="stateErrorMessage"
                      class="error"
                  ></span>
                </div>

                <div
                    class="input-field"
                    :class="{ 'field-error': phoneError }"
                >
                  <div>
                    <input
                        id="download_phone"
                        type="tel"
                        required="required"
                        class="input"
                        v-model="phone"
                        ref="phoneRef"
                    >
                    <label for="download_phone" class="label">{{ labels.phone }}</label>
                    <span v-html="phoneErrorMessage" class="error"></span>
                  </div>
                </div>

                <template v-if="isCommentsRequired">
                  <div class="input-field">
                    <textarea id="comments" class="textarea" v-model="comments" required></textarea>
                    <label for="comments" class="label">Comments (optional)</label>
                  </div>
                </template>

                <div class="form-checkbox">
                  <div class="checkbox" v-show="isEuroZone">
                    <label id="download_checkmark" for="download_check_me">
                      <div class="input-check">
                        <input type="checkbox" id="download_check_me" required="required" v-model="check_me">
                        <span class="check"></span>
                      </div>

                      <span class="checkbox-text">
                         <span v-html="labels.checkbox"></span>
                         <span class="error-checkbox" v-if="privacyPolicyError" v-html="labels.checkbox_validation"></span>
                      </span>

                    </label>
                  </div>

                  <div class="checkbox" v-show="!isEuroZone">
                    <label id="download_checkmark" for="download_check_me">
                      <span class="checkbox-text" v-html="labels.no_checkobox">
                      </span>
                    </label>
                  </div>

                </div>

                <div class="input-field btn-wrap">
                  <button type="submit" class="btn blue" @click="submitForm($event)">{{submitButtonLabel}}</button>
                </div>






              </form>
            </div>
          </div>
        </div>

        <!--            Thank you form block-->
        <div id="thank-you-form-block" v-html="thankYouBlockContent" v-show="thankYouBlockShow">

        </div>


        <div class="overlay_loader">
          <div class="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

      </div>

    </div>

    <!--    Email: {{email}}<br>-->
    <!--    Firstname: {{firstname}}<br>-->
    <!--    Lastname: {{lastname}}<br>-->
    <!--    Title: {{title}}<br>-->
    <!--    Company: {{company}}<br>-->

  </section>
</template>

<script>
// eslint-disable-next-line
// import { isProxy, toRaw } from 'vue';
// import Choices from "choices.js";
import intlTelInput from "intl-tel-input";
// import europe_zone_country from "./libs/eurozone";
import europe_zone_country from "@/components/libs/eurozone";
import getLicense from "@/components/libs/getLicense";
// eslint-disable-next-line
import {useCookies} from "vue3-cookies";


// eslint-disable-next-line
// import {ErrorMessages, filterErrors, sortErrors} from "@/components/libs/errors_function";

let ErrorMessages, filterErrors, sortErrors;
const language = window.main_form_config.language ?? 'en';

let module;
if (language !== 'en') {
  module = await import(`@/components/libs/${language}/errors_function.js`)
} else {
  module = await import('@/components/libs/errors_function.js')
}

({ ErrorMessages, filterErrors, sortErrors } = module)

let labels
if (language !== 'en') {
  module = await import(`@/components/libs/${language}/labels.js`)
} else {
  module = await import('@/components/libs/labels.js')
}

({labels} = module)
// console.log('labels', labels)

// console.log('ErrorMessages', ErrorMessages);



import initSelectors from "@/components/libs/initSelectors";
// import {h} from "vue";

// let globalConfig = {};

// import { onMounted } from 'vue';

export default {
  name: "App",
  components: {},
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {

      formTitle: "What’s next?",
      language: 'en',
      labels: null,
      enterPoint: '',


      //configs
      cbs: {},
      // activeForm: 'quote',
      activeForm: 'pricing',
      activeProducts: {},
      loading: false,
      menu_headers: [],
      config: null,
      countryShow: false,
      configProducts: {},
      showSubProduct: false,
      subProductLabel: "",
      thankYouBlockContent: "",
      thankYouBlockShow: false,
      StatesObj: null,
      // config: null,

      // phoneShow: false,

      //data
      firstname: '',
      lastname: '',
      company: '',
      email: '',
      country: '',
      countryState: '',
      title: '',
      phone: '',
      // phone: '+380505627641',
      product: '',
      sub_product: '',
      comments: '',

      //additional flag
      check_me: false,

      // validVSANSubProduct: false,
      // validVSANFreeSubProduct: false,
      // validSANNASSubProduct: false,
      // valid_vHCI_subProduct: false,

      // products: [],
      // sub_products: [],

      detectedCountry: '',

      //refs
      countryRef: null,
      stateRef: null,
      intlTelInputRef: null,
      productRef: null,
      subProductRef: null,

      //errors
      errors: {},
      privacyPolicyError: false

    }
  },
  async created() {

    document.querySelector('body').classList.add('preloader');
    //callbacks
    if(    window.main_form_config != null
        && typeof window.main_form_config === 'object'
        && window.main_form_config.callbacks != null ) {

      const main_form_cb = window.main_form_config.callbacks;

      this.formTitle = window.main_form_config.formTitle ?? this.formTitle;

      if(typeof main_form_cb === 'object') {
        for(let key in main_form_cb){
          if(typeof main_form_cb[key] === 'function') {
            switch (key) {
              case 'mounted':
              case 'submitCb':
              case 'beforeSend':
              case 'successSend':
              case 'failureSend':
                this.cbs[key] = main_form_cb[key];
                break;
            }
          }
          else{

            if(Array.isArray(this.cbs['data'])) {
              this.cbs['data'].push(main_form_cb[key])
            }
            else{
              this.cbs['data'] = [];
              this.cbs['data'].push(main_form_cb[key]);
            }
          }
        }

        // console.log('this.cbs', this.cbs);

      }

    }

    this.language = window.main_form_config.language ?? 'en'

    this.labels = labels

    //read config form json
    let fullConfigPath = '';
    // console.log('window.main_form_config', window.main_form_config);

    if (   typeof window.main_form_config === 'object'
        && window.main_form_config.configUrl != null) {
      fullConfigPath = window.main_form_config.configUrl;
    }
    else {
      return;
    }

    this.activeProducts = window.main_form_config.activeProducts ?? null
    this.enterPoint = window.main_form_config.enterPoint ?? ''

    //read config from remote file
    const config = await this.getFormConfig(fullConfigPath);
    this.config = config;

    // console.log('config', config)

    this.menu_headers = config.headers;

    await initSelectors.call(this)

    //читаем строку и смотрим нет ли там принудительного переключения формы
    const hash = window.location.hash.substring(1);

    switch (hash) {
      case 'download':
        this.activeForm = 'download';
        this.setProductsList('download');
        break;

      case 'pricing':
      case 'quote':
        this.activeForm = 'pricing';
        this.setProductsList('pricing');
        break;

      default:

        // иначе применяем установки из файла конфигурации
        // activeHeader
        if(Object.prototype.hasOwnProperty.call(config, "activeHeader")) {
          switch (config['activeHeader']) {
            case 'demo':
            case 'download':
            case 'pricing':
            case 'quote':
              this.activeForm = config['activeHeader'];
              break;
          }
        }

        break;

    }

    //was in mounted
    await this.initFunction();

    this.mountedCallback()
    //was in mounted

    document.querySelector('body').classList.remove('preloader');

    this.loading = true;

  },
  watch: {
    activeForm(newForm) {

      this.thankYouBlockShow = false;

      this.errors = {};

      this.setProductsList(newForm);

      this.setSubProductList();

      this.setThankYouBlock(newForm);

      // this.getLicense();
    },
    product() {

      this.errors = {};

      this.setSubProductList();

      // this.getLicense();
    },
    sub_product() {

      if( this.sub_product !== '') {
        delete(this.errors.product);
      }

    },

    country(newCountry) {

      this.fillStatesByCountry(newCountry)

    }

  },
  mounted() {

    // this.countryRef = new Choices(this.$refs.countryRef, {
    //   searchEnabled: false,
    //   searchChoices: false,
    //   shouldSort: false,
    //   itemSelectText: "",
    //   allowHTML: true,
    // });
    //
    // this.productRef = new Choices(this.$refs.productRef, {
    //   searchEnabled: false,
    //   searchChoices: false,
    //   shouldSort: false,
    //   itemSelectText: "",
    //   allowHTML: true,
    // });
    //
    // this.subProductRef = new Choices(this.$refs.subProductRef, {
    //   searchEnabled: false,
    //   searchChoices: false,
    //   shouldSort: false,
    //   itemSelectText: "",
    //   allowHTML: true,
    // });
    //
    // this.initFunction();
    //
    // this.mountedCallback()

  },
  computed: {

    sub_product_class_selected() {
      // return this.sub_product !== ' ' ? 'selected' : 'not_selected';
      return this.sub_product !== ' ';
    },

    countHeaders() {
      return 'count-headers-' + this.menu_headers.length;
    },


    firstnameError() {
      const key = "firstname";
      return this.checkFieldError(key);
    },

    firstnameErrorMessage() {
      const key = "firstname";
      return this.generateErrorMessage(key);
    },

    lastnameError() {
      const key = "lastname";
      return this.checkFieldError(key);
    },

    lastnameErrorMessage() {
      const key = "lastname";
      return this.generateErrorMessage(key);
    },

    emailError() {
      const key = "email";
      return this.checkFieldError(key);
    },

    emailErrorMessage() {
      const key = "email";
      return this.generateErrorMessage(key);
    },

    titleError() {
      const key = "title";
      return this.checkFieldError(key);
    },

    titleErrorMessage() {
      const key = "title";
      return this.generateErrorMessage(key);
    },

    companyError() {
      const key = "company";
      return this.checkFieldError(key);
    },

    companyErrorMessage() {
      const key = "company";
      return this.generateErrorMessage(key);
    },

    countryError() {
      const key = "country";
      return this.checkFieldError(key);
    },

    countryErrorMessage() {
      const key = "country";
      return this.generateErrorMessage(key);
    },

    stateError() {
      const key = "state";
      return this.checkFieldError(key);
    },

    stateErrorMessage() {
      const key = "state";
      return this.generateErrorMessage(key);
    },

    phoneError() {
      const key = "phone";
      return this.checkFieldError(key);
    },

    phoneErrorMessage() {
      const key = "phone";
      return this.generateErrorMessage(key);
    },

    // VSANSubProductErrorClass() {
    VSANSubProductError() {
      const key = "product";
      return this.generateErrorMessage(key);
    },

    VSANSubProductErrorMessage() {
      const key = "product";
      return this.generateErrorMessage(key);
    },


    submitButtonLabel () {

      const menu = this.menu_headers;
      const active = this.activeForm;

      const value = menu.reduce((acc, value) => {
        if(value.id === active) {
          acc = value.label
        }
        return acc
      }, '')

      switch (this.activeForm) {
        case 'quote':
        case 'pricing':
          return  value || 'Send me pricing';
        case 'demo':
          return  value || 'Book a demo';
        case 'download':
          return  value || 'Download';
        default:
          return  value || 'Download';
      }

    },
    isCommentsRequired () {

      switch (this.activeForm) {
        case 'quote':
        case 'pricing':
        case 'demo':
          return true;
      }

      return false;

    },
    isEuroZone() {

      if(europe_zone_country == null) {
        return true;
      }

      return europe_zone_country.includes(this.country);

    }

  },
  methods: {

    fillStatesByCountry(country) {

      this.stateRef.removeActiveItems();
      this.stateRef.clearChoices();

      this.countryState = '';


      if (!this.StatesObj || !Object.prototype.hasOwnProperty.call(this.StatesObj, country)) {
        // this.stateRef.setValue([{ value: ' ', label: 'State' }])
        // this.stateRef.setChoiceByValue(' ')
        return
      }

      const data = this.StatesObj[country]
      const arr = []

      arr.push({ value: ' ', label: 'State' })

      for(const item in data) {
        arr.push({ value: data[item], label: item })
      }

      // console.log('arr', arr)

      this.stateRef.setValue(arr);
      this.stateRef.setChoiceByValue(' ')

    },

    initUrlHash () {

      const hash = window.location.hash.substring(1);

      switch (hash) {
        case 'download':
          this.activeForm = 'download';
          this.setProductsList('download');
          break;
        case 'pricing':
        case 'quote':
          this.activeForm = 'pricing';
          this.setProductsList('pricing');
          break;
      }

    },

    mountedCallback () {

      // this.urlCallback()

      if(this.cbs.mounted !== null && typeof this.cbs.mounted === 'function') {
        this.cbs.mounted(this);
      }

    },

    // async getCookieDetail() {
    getCookieDetail() {

      // console.log('getCookieDetail');

      const cookieValue = this.cookies.get("lightenc");
      // const cookieValue = 'c4ed7d59bca48177c21d155c391b922261f9ecb48ee49bb3196c9c2c256ea08388b1d66a3f0ddf6b2533c19932d26ca400a19ff8cd139817954e2ecc7f69b8658f18dff35937062886e78b17116ec02d5a3848e263a386fd5070e5eaabc6909acdaf7bb17cb16841b59b063567fb0b984ba22850f69b200793f124ea027c780f76cceaead3d782a08595158b2935ef8d0c3b41806efd4a81f90afc29807e14c72558b0e6510fb7dd7cecf8c0ce468f43d28d42a09383f9425b8344d7d79786206d9c42b92a92e99782e4ad3445caa07b53f78a70274ed53731066d7a59ecc2700207d5d3fe0dd1ccd66ecdc8522667618e70d3b6307dcd65e20acc21a1e35fb9c6b1efa7d73ed3e18f188fe4110fec614a1f9b2896ddea4e229712d43f3f67b48e20d20ee910bf3977fad45a38a55c0baa05e3a9fcdf955a438fcbe98f13234937d45aa376c8074fd2a3f7b1a93ad8e9d01cb4ac49014a3b8ed339017c66002bca87d28c7663ef27dd574beda8158dac753decedee368e75b0bad78cde52c507ea7f0b95af546c8f3cda8745618c95e9ad3ae668cd52f7170a98157e911c5ecc781feccc42e603278c22d9798e0f60916dc57c45dc61a1f636ddd55a4550141caf45bfd8a53c737550bdca154b593fd8ae27181d230757cca7f605c5ad493f06cc741d964dc486447c541c33c93378a6';
      // console.log('cookieValue', cookieValue);
      //
      const formData = new URLSearchParams({ cookieName: cookieValue });
      //
      fetch(
          "https://www.starwindsoftware.com/cookie-detail.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData,
          }
      )
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        // console.log('data', data);
        // return data;

        if(data.status === null) {
          return;
        }

        if( (data.result === null) || (data.result === false)){
          return;
        }

        if( (data.type === null) || (data.type !== 'cookie-detail') ) {
          return;
        }



        if (data.result.firstname !== null) {
          this.firstname = data.result.firstname;
        }

        if (data.result.lastname !== null) {
          this.lastname = data.result.lastname;
        }

        if (data.result.email !== null) {
          this.email = data.result.email;
        }

        if (data.result.title !== null) {
          this.title = data.result.title;
        }

        if (data.result.company !== null) {
          this.company = data.result.company;
        }

        if (data.result.country !== null) {
          const country = data.result.country;
          // const country = 'Poland';
          this.countryRef.setChoiceByValue(country);
          this.country = country;
        }

        if ((data.result.phone !== null) && (data.result.phone !== undefined)) {

          // console.log('data.result.phone', data.result.phone);

          this.intlTelInputRef.setNumber(data.result.phone);

          let phone = data.result.phone;
          phone = phone.replace("+", ""); //убираем +

          this.intlTelInputRef.setNumber(phone); //set phone
          this.phone = phone; //set model phone

          const code = this.intlTelInputRef.getSelectedCountryData();

          if (code.dialCode !== "") {
            phone = phone.replace(code.dialCode, ""); //clean code in number
            this.phone = phone;
          }

        }

        // console.log('умничка');
        // console.log('моё ты солнышко');



      });


    },

    // eslint-disable-next-line
    validEmail(options) {

      // eslint-disable-next-line
      if (window.successFormSubmit === null) {
        return;
      }

      // eslint-disable-next-line
      if(typeof window.successFormSubmit !== 'function') {
        return;
      }

      const url = 'https://www.starwindsoftware.com/validemail.js';

      const opts = {
        method: 'POST',
        body: options.email
      };

      fetch(url, opts).then((data) => {
        return data.json();
      })
      .then((response) => {

        options.valid = response.emailStatus;
        options.user  = response.cid;

        // console.log('validEmail', response, options);

        window.successFormSubmit(options);

      });

    },

    generateErrorMessage(field) {
      if (this.errors[field] != null) {
        const rule = this.errors[field][0];
        return ErrorMessages[field][rule];
      }
      return "";
    },
    checkFieldError(field) {
      return this.errors[field] != null;
    },

    // eslint-disable-next-line
    checkErrors(res) {

      // eslint-disable-next-line
      const errors =  {
        length: 0
      };

      // console.log('checkErrors func: ', res);

      for(let key in res) {
        if( Object.prototype.hasOwnProperty.call(errors, res[key]['field']  ) ) {
          errors[res[key]['field']].push(res[key]['rule']);
        }
        else{
          errors[ res[key]['field'] ] = [ res[key]['rule'] ];
        }
        errors.length += 1;
      }

      const sortErr = sortErrors(errors);

      this.errors =  filterErrors(sortErr);

      // console.log('errors', this.errors);

    },
    checkRequest(data) {

      this.checkErrors(data);

    },

    // eslint-disable-next-line
    pointFormValidation(url, data, success, failure) {

      const params = new URLSearchParams();

      for(let key in data) {
        params.append(key, data[key]);
      }


      // eslint-disable-next-line
      const options = {
        method: `POST`,
        body: params
      };

      document.querySelector('body').classList.add('preloader');

      if(this.cbs.beforeSend !== null && typeof this.cbs.beforeSend === 'function') {
        // this.cbs.beforeSend(this);
        this.cbs.beforeSend(this, params);
      }

      fetch(url, options)
          .then((data) => {
            return data.json();
          })
          .then((data) => {

            document.querySelector('body').classList.remove('preloader');
            // console.log('remote data:', data);

            if((data.success !== null) && data.success) {
              success('ok');

              if(this.cbs.successSend !== null && typeof this.cbs.successSend === 'function') {
                this.cbs.successSend(this, data);
              }

            }
            else {
              failure(data.data);

              if(this.cbs.failureSend !== null && typeof this.cbs.failureSend === 'function') {
                this.cbs.failureSend(this, data);
              }

            }


          })
          .catch((error) => {
            console.log('resp failure data:', error)
            // someErrorFunction(error);
          });



    },

    isValidPhone() {

      let result = false;
      let extension = '';
      let number = '';
      let phoneCountry = '';

      if(this.intlTelInputRef.isValidNumber()) {
        result = true;
        extension = this.intlTelInputRef.getExtension();

        //very interesting
        // number = this.intlTelInputRef.getNumber(intlTelInputUtils.numberFormat.E164);
        number = this.intlTelInputRef.getNumber(0)
        phoneCountry = this.intlTelInputRef.getSelectedCountryData().iso2
      }

      return {
        result,
        extension,
        number,
        phoneCountry
      };

    },

    setModel() {

      const model = {};

      //check phone
      const modelPhone = this.isValidPhone();
      // console.log('model Phone', modelPhone);
      const lic = this.getLicense();
      // console.log('model license', lic);

      model.license       = lic.license;
      model.product       = this.product;

      model.firstname     = this.firstname;
      model.lastname      = this.lastname;
      model.company       = this.company;
      model.email         = this.email;
      model.country       = this.country;
      if(this.countryState !== '') {
        model.state2026DC   = this.countryState;
        model.state         = this.countryState; //на всяк випадок
      }
      model.state2026DCF = 'true';

      model.title         = this.title;
      model.comments      = this.comments ?? "";

      model.phone2        = modelPhone.number ?? '';
      model.phoneStandart = modelPhone.number ?? '';
      model.phoneVersion  = 'v2023';
      model.phoneExt      = modelPhone.extension ?? '';
      model.validPhone    = modelPhone.result;
      model.phoneCountry  = modelPhone.phoneCountry ?? '';

      model.url             = window.location.href;
      model.formType        = this.activeForm;
      model.Scenario_202306 = lic.Scenario_202306 ?? '';

      switch (model.product) {
        case 'StarWind NVMe-oF Initiator Trial':
        case 'StarWind NVMe-oF Initiator':
          if(this.sub_product.trim() !== '') {
            model.nvme_hosts = this.sub_product;
          }
          break;

        case 'san-nas-trial':
        case 'san-nas-free':
        case 'free-nas-san':
          if ( model.Scenario_202306 !== null ) {
            model.sub_product_san_nas = model.Scenario_202306;
          }
          break;
        // case '':
      }

      // console.log('-' + this.sub_product.trim() + '-');

      // model.validVSANSubProduct = this.sub_product.trim() !== '';

      model.validVSANSubProduct     = lic.validVSANSubProduct;
      model.validVSANFreeSubProduct = lic.validVSANFreeSubProduct;
      model.validSANNASSubProduct   = lic.validSANNASSubProduct;
      model.valid_vHCI_subProduct   = lic.valid_vHCI_subProduct;



      //Pricing Demo Scenarios
      // model['Demo_Scenario_2025']    = '';
      // model['Pricing_Scenario_2025'] = '';

      if ( this.activeForm === 'demo' && this.product === 'StarWind Virtual SAN') {
        model['Demo_Scenario_2025'] = this.sub_product;
      }

      if ( this.activeForm === 'demo' && this.product === 'StarWind HyperConverged Appliance') {
        model['Demo_Scenario_2025'] = this.sub_product;
      }

      if ( this.activeForm === 'demo' && this.product === 'StarWind vHCI Appliance') {
        model['Demo_Scenario_2025'] = this.sub_product;
      }

      if ( this.activeForm === 'demo' && this.product === 'Virtual Backup Appliance') {
        model['Demo_Scenario_2025'] = this.sub_product;
      }

      if ( this.activeForm === 'pricing' && this.product === 'StarWind Virtual SAN') {
        model['Pricing_Scenario_2025'] = this.sub_product
      }

      if ( this.activeForm === 'pricing' && this.product === 'StarWind HyperConverged Appliance') {
        model['Pricing_Scenario_2025'] = this.sub_product
      }

      if ( this.activeForm === 'pricing' && this.product === 'StarWind vHCI Appliance') {
        model['Pricing_Scenario_2025'] = this.sub_product
      }

      if ( this.activeForm === 'pricing' && this.product === 'Virtual Backup Appliance') {
        model['Pricing_Scenario_2025'] = this.sub_product
      }

      // return model;
      return {
        model: model,
        url: lic.url
      }


    },

    submitForm(e) {

      e.preventDefault();

      if(this.cbs.submitCb !== null && typeof this.cbs.submitCb === 'function') {
        this.cbs.submitCb(this);
      }


      // console.log('submitForm');
      // console.log('check me:', this.check_me);


      this.privacyPolicyError = false;
      if(this.isEuroZone && !this.check_me) {
        this.privacyPolicyError = true;
        return;
      }

      this.errors = {};

      // const model = this.setModel();
      const {url, model} = this.setModel();

      // console.log('activeForm', this.activeForm)

      // console.log('model', model);
      // console.log('ok send data');

      // eslint-disable-next-line
      const success = (data) => {

        document.getElementById('forms3').scrollIntoView({behavior: "smooth"})

        if (this.activeForm === 'download') {

          let product_name_2024 = ''

          switch (this.product) {
            case "virtual_san":
              product_name_2024 = "Virtual SAN (VSAN)";
              break;
            case "vsan_free_oct18":
              product_name_2024 = "VSAN Free";
              break;
            case "Virtual HCI Appliance (vHCI)":
              product_name_2024 = "Virtual HCI Appliance (VHCA)";
              break;
            case "vtl_oct18":
              product_name_2024 = "Virtual Tape Library (VTL)";
              break;
            case "vtl_free_oct18":
              product_name_2024 = "VTL Free";
              break;
            case "tape_redirector_oct18":
              product_name_2024 = "Tape Redirector";
              break;
            case "StarWind NVMe-oF Initiator Trial":
              product_name_2024 = "NVMe-oF Initiator";
              break;
            case "StarWind NVMe-oF Initiator":
              product_name_2024 = "NVMe-oF Initiator Free";
              break;
            case "v2v":
              product_name_2024 = "V2V Converter / P2V Converter";
              break;
            case "StarWind V2V Converter":
              product_name_2024 = "V2V Converter / P2V Converter";
              break;
            case "StarWind HCI Evaluation Kit":
              product_name_2024 = "StarWind HCI Evaluation Kit";
              break;
            case "deduplication_analyzer":
              product_name_2024 = "Deduplication Analyzer";
              break;
            case "StarWind rPerf":
              product_name_2024 = "RDMA Performance Benchmark (rPerf)";
              break;
            case "san-nas-trial":
              product_name_2024 = "SAN & NAS";
              break;
            case "san-nas-free":
              product_name_2024 = "SAN & NAS Free";
              break;
            case "ram_disk":
              product_name_2024 = "RAM Disk";
              break
            default:
              product_name_2024 = this.product
          }

          const contentDefault = this.labels.contentDefault.replace('{product_name_2024}', product_name_2024)
              .replace('{this.email}', this.email)

          const contentNoLic = this.labels.contentNoLic.replace('{product_name_2024}', product_name_2024)
              .replace('{this.email}', this.email)

          switch (this.product) {
            case 'RAM Disk':
            case 'Deduplication Analyzer':
            case 'V2V Converter':
            case 'StarWind V2V Converter':
            case 'v2v':
            case 'StarWind rPerf':
              this.thankYouBlockContent = contentNoLic;
              this.thankYouBlockShow = true;
              return;
          }

          if (product_name_2024 !== '') {
            this.thankYouBlockContent = contentDefault;
          } else {
            this.thankYouBlockContent = this.labels.contentDefault2.replace('{this.email}', this.email)
                .replace('{product_name_2024}', product_name_2024)
          }

        }


        this.thankYouBlockShow = true;

      };

      const failure = (data) => {

        // console.log('failure func', data);

        document.getElementById('forms3').scrollIntoView({behavior: "smooth"})

        this.checkRequest(data);

      };


      this.pointFormValidation(url, model, success, failure);




    },

    getLicense() {

      if ( this.enterPoint !== '' ) {
        return getLicense(this.showSubProduct, this.activeForm, this.product, this.sub_product, this.enterPoint)
      }

      return getLicense(this.showSubProduct, this.activeForm, this.product, this.sub_product);

    },

    setSubProductList() {

      // console.log('setSubProductList')

      //очистить список sub продуктов
      this.subProductRef.clearStore();

      if(this.config === null) {
        return;
      }

      if(!Object.prototype.hasOwnProperty.call(this.config, "products")) {
        return;
      }

      const config  = this.config;
      const header  = this.activeForm;
      const product = this.product;

      const data = config['products'].filter((curr) => curr['for'] === header);


      const item = data[0].list.filter((cur) => cur.value === product);

      if(!item[0]) {
        this.showSubProduct = false;
        return;
      }

      if(!Object.prototype.hasOwnProperty.call(item[0], 'sub_products')){
        this.showSubProduct = false;
        return;
      }

      const items = [];

      item[0].sub_products.map((cur) => {
        items.push({'value': cur.value, 'label': cur.label});
      });

      // console.log('subProductLabel item[0]', item[0]);
      this.subProductLabel = item[0].sub_product_label;
      // console.log('subProductLabel', this.subProductLabel );


      this.subProductRef.setValue(items);

      //устанавливаем первый подпродукт, как выбранный
      const activeSubProduct = item[0].sub_products[0].value;

      this.subProductRef.setChoiceByValue(activeSubProduct);
      this.sub_product = activeSubProduct;

      this.showSubProduct = true;

    },

    setProductsList(newForm) {

      // console.log('setProductsList', newForm)

      if(this.config === null) {
        return;
      }

      if(!Object.prototype.hasOwnProperty.call(this.config, "products")) {
        return;
      }

      //вычитываем продукты из конфига

      const config = this.config;
      // if(isProxy(config)) {
      //   config = toRaw(this.config);
      // }

      const data = config['products'].filter((curr) => curr['for'] === newForm);
      // console.log('data', data);

      if(!data.length) {
        return;
      }

      const products = [];

      let activeProduct = "";

      data.map((cur) => {

        if( (cur.activeProduct !== null) && (cur.activeProduct !== "") ) {
          activeProduct = cur.activeProduct;
        }

        cur.list.map((item) => {
          // products.push([item.value, item.label]);
          products.push( { value: item.value, label: item.label } );
        });

      });

      if(this.activeProducts !== null) activeProduct = this.activeProducts[newForm] ?? activeProduct

      //очистить список продуктов
      this.productRef.clearStore();

      //заполнить новыми продуктами
      this.productRef.setValue(products);


      //проверяем есть ли продукт в строке запроса и он соответствует типу активной формы
      const urlParams = new URLSearchParams(window.location.search);
      let hash = window.location.hash.substring(1);

      if(hash === 'quote') {
        hash = 'pricing';
      }

      if (urlParams.has('product') && hash === newForm) {

        const product = urlParams.get('product')

        const exist = products.filter((cur) => cur.value === product);

        if(!!exist.length === true) {
            this.productRef.setChoiceByValue(product);
            this.product = product;
            return;
        }

      }

      //устанавливаем выбранный продукт
      if( activeProduct !== "" ) {
        this.productRef.setChoiceByValue(activeProduct);
        this.product = activeProduct;
      }



    },

    setThankYouBlock(newForm) {

      // switch (this.activeForm) {
      //   case 'download':
      //   case 'download':
      //   case 'download':
      //
      // }
      // let thankYouBlock = '';
      // console.log('thankYouBlock', newForm, thankYouBlock);

      // console.log('this.config', this.config)
      if(this.config === null) {
        return;
      }

      if(!Object.prototype.hasOwnProperty.call(this.config, "thankYouBlock")) {
        return;
      }

      const config = this.config;

      const data = config['thankYouBlock'].filter((curr) => curr['for'] === newForm);

      if( !data.length ) {
        return;
      }

      const html = data[0].html.replace(/\\"/g, "");
      // const html = data[0].html;
      // console.log('html', html);
      this.thankYouBlockContent = html;


    },

    menuItemClick(value, event) {

      if (event) {
        event.preventDefault();
      }

      this.activeForm = value;

      const hashMap = {
        pricing: 'quote',
        quote: 'quote'
      }

      window.location.hash = hashMap[value] || value

    },

    async getFormConfig(url) {
      const response = await fetch(
          url,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
      );
      return response.json();
    },

    async initFunction() {
      await this.fillCountries(); //заполняем страны
      await this.getStates();

      this.fillStatesByCountry(this.country);

      await this.setPhonePlugin(); //подключаем плагин телефона

      this.getCookieDetail();
      // await this.getCookieDetail(); //получаем куки
    },

    async fillCountries() {
      // console.log('fillCountries');

      const data = await this.getCountryList();

      const arr = [];

      for (const item in data.countries) {
        arr.push({ value: item, label: item });
      }

      this.countryRef.setValue(arr);

      // console.log(data.detectedCountry)United States
      if (data.detectedCountry !== "") {
        this.countryRef.setChoiceByValue(data.detectedCountry);
        this.country = data.detectedCountry;
        this.detectedCountry = data.detectedCountry;
      }
      else {
        this.countryRef.setChoiceByValue('United States');
        this.country = 'United States';
        this.detectedCountry = 'United States';
      }

      this.countryShow = true; //включаем показ стран

      // console.log(this.detectedCountry)
      // await this.setPhonePlugin(); //подключаем плагин телефона


    },

    async getCountryList() {
      const response = await fetch(
          "https://www.starwindsoftware.com/v21-ajax-countries.js",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
      );
      return response.json();
    },

    async getStates() {

      const url = 'https://www.starwindsoftware.com/resource-library/wp-json/myplugin/v1/states-country';

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        // console.log('HTTP status:', response.status);
        // console.log('HTTP ok:', response.ok);
        // console.log('Content-Type:', response.headers.get('content-type'));

        const data = await response.json();


        if (!response.ok) {
          console.error('Server returned error:', data);
          return;
        }

        this.StatesObj = data;

      } catch (error) {
        console.error('Fetch failed:', error);
      }

    },

    setPhonePlugin() {

      const detectedCountry = this.detectedCountry;

      if (intlTelInput != null) {
        this.intlTelInputRef = intlTelInput(this.$refs.phoneRef, {
          utilsScript:
              "https://www.starwindsoftware.com/assets/libraries/intl-tel-input-17.0.19/build/js/utils.js",
          // utilsScript: loadUtils("build/js/utils.js"),
          preferredCountries: [],
          autoPlaceholder: "aggressive",
          separateDialCode: true,
          initialCountry: "auto",
          geoIpLookup: function(callback) {

            //help for geoIpLookup detail
            // https://github.com/jackocnr/intl-tel-input

            const formData = new URLSearchParams({ country: detectedCountry });
            fetch("https://www.starwindsoftware.com/geoip-detail.js",
                {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: formData,
                }
            )
            .then((res) => res.json())
            .then((data) => callback(data.isoCode))
            .catch(() => callback("US"));

          }
        });


      }
    },

  }
};
</script>

<style scoped>
.countryShow,
#choices--download_state-item-choice-1
{
  display: none;
}
</style>
